import { initializeApp, type FirebaseApp } from 'firebase/app';
import { getAuth, type Auth } from 'firebase/auth';
import { getFirestore, type Firestore } from 'firebase/firestore';
import { getStorage, type FirebaseStorage } from 'firebase/storage';
import { firebaseConfig, isFirebaseConfigured } from './firebase-config';

let appInstance: FirebaseApp | null = null;
let authInstance: Auth | null = null;
let dbInstance: Firestore | null = null;
let storageInstance: FirebaseStorage | null = null;

export const firebaseReady = isFirebaseConfigured();

if (firebaseReady) {
  appInstance = initializeApp(firebaseConfig);
  authInstance = getAuth(appInstance);
  dbInstance = getFirestore(appInstance);
  storageInstance = getStorage(appInstance);
}

// Non-null accessors for code paths that only run when firebaseReady.
export const app = () => appInstance as FirebaseApp;
export const auth = () => authInstance as Auth;
export const db = () => dbInstance as Firestore;
export const storage = () => storageInstance as FirebaseStorage;
